import React from "react"
import OpportunitiesImg from "./OpportunitiesImg"

export default function Opportunities() {
  return (
    <div
      className="row justify-content-around align-items-center pb-5"
      id="opportunities"
    >
      <div className="col-lg-4">
        <h3 className="text-green">New Opportunities</h3>
        <p>
          Prior to Regulation A+, finding private venture investment
          opportunities required having a vast network of business contacts.
          Regular investors now have direct access to these investment types.
        </p>
      </div>
      <div className="col-lg-5">
        <OpportunitiesImg />
      </div>
    </div>
  )
}
